module.exports = __webpack_public_path__ + "static/media/BackgroundImageRegistration.f5080b0d.jpg";